import { ReactComponent as CopyAltSvg } from '@client/new/assets/icons/copy-alt.svg';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { toast } from 'react-hot-toast';
import { clsx } from 'clsx';

// copy to clipboard on desktop browsers or mobile browsers that support it
export const copyToClipboard = (text: string) => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text);
    return;
  }

  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.position = 'fixed';
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.opacity = '0';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  document.execCommand('copy');
  document.body.removeChild(textArea);
};

export const CopyToClipboard = ({
  contentToCopy,
  className,
}: {
  contentToCopy: string;
  className?: string;
}) => {
  const [copied, setCopied] = useState(false);
  return (
    <div
      className={clsx('w-5 h-5 cursor-pointer', className)}
      onClick={() => {
        copyToClipboard(contentToCopy);
        setCopied(true);
        toast.success('Copied to clipboard!');
        setTimeout(() => setCopied(false), 1000);
      }}
    >
      {!copied ? (
        <CopyAltSvg className={clsx('w-5 h-5', className)} />
      ) : (
        <FontAwesomeIcon className="text-green-500" icon={faCheck} />
      )}
    </div>
  );
};
